import { Grid, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { INVESTOR_ICONS } from "../../../data/StaticList";

export default function Investors() {
  const iconItems = INVESTOR_ICONS.filter((x) => Boolean(x?.img));

  const settingsInvestorsIcon: Settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    initialSlide: 0,
    rtl: false,
    pauseOnHover: false,
    swipeToSlide: true,
    draggable: true,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <Grid
      sx={{
        width: "100%",
        paddingTop: { xs: "56px", md: "96px" },
        paddingBottom: { xs: "8px", md: "16px" },
        background: "white",
      }}
    >
      <Grid
        sx={{
          padding: { xs: "0 16px", md: "0 24px" },
          maxWidth: "1440px",
          margin: "auto",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "24px", md: "40px" },
            lineHeight: { xs: "36px", md: "56px" },
            fontWeight: { xs: "700", md: "600" },
            color: "#0A0C0F",
            textAlign: "center",
          }}
        >
          Our investors
        </Typography>

        <Grid sx={{ width: { xs: "90%", md: "75%" }, margin: "24px auto" }}>
          <Slider {...settingsInvestorsIcon}>
            {iconItems.map((item, i) => (
              <Grid key={i} sx={{ padding: "0 12px" }}>
                <Image
                  src={item.img}
                  alt="investors"
                  style={{ objectFit: "contain", borderRadius: "12px" }}
                />
              </Grid>
            ))}
          </Slider>
        </Grid>
      </Grid>
    </Grid>
  );
}

